// extracted by mini-css-extract-plugin
export default {"content":"DeleteUserDialog_content__KqFnE","message":"DeleteUserDialog_message__WUIPe","warning":"DeleteUserDialog_warning__HPtCn","buttons":"DeleteUserDialog_buttons__+kIgh"};